import template from './step-page.html';
import './step-page.global.css';
import { selectors } from '../../../../state';

class StepPageController {
  constructor($transclude, updStore) {
    'ngInject';
    Object.assign(this, { $transclude, updStore });
  }

  isSlotFilled(slot) {
    return this.$transclude.isSlotFilled(slot);
  }

  $onInit() {
    const { connect, getState } = this.updStore;
    this.disconnect = connect(mapStateToThis)(this);
  }

  $onDestroy() {
    this.disconnect();
  }
}

function mapStateToThis(state) {
  const stepCode = selectors.router.currentDataMoveItemType(state);
  const itemDefinition = selectors.itemDefinition.byCode(stepCode);

  return {
    bannerHtml: itemDefinition.bannerHtml(state),
  };
}

export const StepPageComponent = {
  template,
  controller: StepPageController,
  transclude: {
    aboveSectionsContent: '?updStepPageAboveSectionsContent',
    secondarySection: '?updStepPageSecondarySection',
  },
  bindings: {
    headerTitle: '@',
    headerSubtitle: '@',
  },
};
